import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  fetchCategoriasAPI,
          createCategory as createCategoryAPI,
          deleteCategory,
          updateCategory as updateCategoryAPI,
          fetchCategoriasByIdFederationAPI
        } from '../../services/categoriaService';

const initialState = {
  categories: [],
  loading: false,
  error: null,
};

export const fetchCategoriasByIdFederation = createAsyncThunk(
  'torneo/fetchTournaments',
  async (federationId, { rejectWithValue }) => {
    try {
      const data = await fetchCategoriasByIdFederationAPI(federationId);
      //console.log('dataSlice', data);
      return data; // data es un arreglo de torneos
    } catch (error) {
      return rejectWithValue(error.message || 'Error al cargar los torneos');
    }
  }
);

export const fetchCategorias = createAsyncThunk(
  "categories/fetchCategorias",
  async (idFederacion, { rejectWithValue }) => {
    try {
      const data = await fetchCategoriasAPI(idFederacion);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error al obtener categorías");
    }
  }
);

export const removeCategory = createAsyncThunk(
  'categories/removeCategory',
  async (idCategoria, { rejectWithValue }) => {
    try {
      const response = await deleteCategory(idCategoria);
      return idCategoria;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al eliminar la categoría');
    }
  }
);

export const createCategory = createAsyncThunk(
  'categories/createCategory',
  async (newCategory, { rejectWithValue }) => {
    try {
      const data = await createCategoryAPI(newCategory);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al crear categoría');
    }
  }
);

export const updateCategory = createAsyncThunk(
  'categories/updateCategory',
  async ({ idCategoria, data }, { rejectWithValue }) => {
    try {
      const response = await updateCategoryAPI(idCategoria, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al modificar la categoría');
    }
  }
);

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategorias.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategorias.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategorias.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Manejo de fetchCategoriasByIdFederation
      .addCase(fetchCategoriasByIdFederation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoriasByIdFederation.fulfilled, (state, action) => {
        state.categories = action.payload;
        state.loading = false;
      })
      .addCase(fetchCategoriasByIdFederation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(removeCategory.fulfilled, (state, action) => {
        state.categories = state.categories.filter(
          (category) => category.id_categoria !== action.payload
        );
      })
      .addCase(removeCategory.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.categories.push(action.payload);
      })
      .addCase(createCategory.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        const updatedCategoryIndex = state.categories.findIndex(
          (category) => category.id_categoria === action.payload.id_categoria
        );
        if (updatedCategoryIndex !== -1) {
          state.categories[updatedCategoryIndex] = action.payload;
        }
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.error = action.payload;
      })
  },
});

export default categoriesSlice.reducer;
